import { connect } from 'react-redux';
import Dashboard from '../components/Dashboard';
import { getAggregatedData, getOpenCases, getNotifications, getAggregatedDataDistributor, getAgentList, getOpenCasesDistributor, getAgencyProductListPersona } from '../store/actions/authActions';

const mapStatetoProps = (state) => ({
  agentRank: state.auth.agentRank,
  monthlyData: state.auth.monthlyData,
  iaiRate: state.auth.iaiRate,
  msgCode: state.auth.msgCode,
  msgText: state.auth.msgText,
  productAccess: state.auth.productAccess,
  productEligible: state.auth.productEligible,
  productId: state.auth.productId,
  productLibrary: state.auth.productLibrary,
  qualityScore: state.auth.qualityScore,
  quarterlyData: state.auth.quarterlyData,
  statusCode: state.auth.statusCode,
  underwritingInaccuracy: state.auth.underwritingInaccuracy,
  weeklyData: state.auth.weeklyData,
  yearlyData: state.auth.yearlyData,
  openCases: state.auth.openCases,
  notificationMessage: state.auth.notificationMessage,
  relationalType: state.auth.relationalType,
  userSourceCode: state.auth.userSourceCode,
  totalNumAgencies: state.auth.totalNumAgencies,
  totalNumAgents: state.auth.totalNumAgents,
  agentList: state.auth.agentList,
  productList: state.auth.productList,
  agencyList: state.auth.agencyList,
  distributorList: state.auth.distributorList,
});

const DashboardContainer = connect(mapStatetoProps, {
    getAggregatedData, getOpenCases, getNotifications, getAggregatedDataDistributor, getAgentList, getOpenCasesDistributor, getAgencyProductListPersona
})(({ toggleDrawer, ...props }) => (
    <Dashboard toggleDrawer={toggleDrawer} {...props}></Dashboard>
  ));

export default DashboardContainer;
